import { ApiQuery, SortDirections } from "../filters/types";
import { NetworkColumns } from "./types";

// // // //

export const DEFAULT_NETWORK_LIST_QUERY: ApiQuery = {
    sort: {
        direction: SortDirections.asc,
        field: NetworkColumns.name,
    },
    pagination: {
        page: 1,
        perPage: 25,
    },
};
